import {keepPreviousData} from "@tanstack/react-query";
import {useCustomQuery} from "~/query/useCustomQuery.ts";
import {queryHttp} from "~/query/queryHttp.ts";
import type {PageResponse} from "~/services/ApiTypes.ts";
import {supplierClusterMemberListUrl} from "../services/supplier360Urls";
import type {SupplierClusterMember, SupplierClusterMemberListParams} from "../types/Supplier360Types";

/**
 * Paginated "Raw view" rows (`GET supplier_360/cluster_member/`). `search` hits `normalized_name`
 * server-side — docs §2.2.
 *
 * `options.enabled` lets a caller hold the request back until the rows are actually on screen;
 * it is ANDed with the databag-id guard, never replaces it.
 */
export function useSupplierClusterMembersQuery(
    databagId: number,
    params: SupplierClusterMemberListParams,
    options: {enabled?: boolean} = {},
) {
    const {enabled = true} = options;
    return useCustomQuery({
        queryKey: [supplierClusterMemberListUrl(databagId, params)] as const,
        queryFn: async () => (await queryHttp.get<PageResponse<SupplierClusterMember>>(supplierClusterMemberListUrl(databagId, params))).data,
        enabled: enabled && Boolean(databagId),
        placeholderData: keepPreviousData,
        showErrorNotification: true,
    });
}
